import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { CheckIcon } from '@mssgme/icons';
import { IconButton } from '@mssgme/ui';

import styles from './ArchiveToggle.scss';

ArchiveToggle.propTypes = {
    isActive: PropTypes.bool,
    onToggle: PropTypes.func,
};

export default function ArchiveToggle({ isActive, onToggle }) {
    return (
        <IconButton onClick={onToggle} className={cn({ [styles.active]: isActive })}>
            <CheckIcon size={24} />
        </IconButton>
    );
}
